import { UIFlightData, UIClientFetchError } from "@flights/types";
import { ActionsUnion, createAction } from "@bookingcom/flights-core";

export enum ActionTypes {
  fetch = "preFetchedFlightDetails/fetch",
  fetchSuccess = "preFetchedFlightDetails/fetchSuccess",
  fetchError = "preFetchedFlightDetails/fetchError",
  reset = "preFetchedFlightDetails/reset"
}

export const actions = {
  fetch: createAction(() => ({
    type: ActionTypes.fetch,
    payload: {}
  })),
  fetchSuccess: createAction((flights: UIFlightData[]) => ({
    type: ActionTypes.fetchSuccess,
    payload: { flights }
  })),
  fetchError: createAction((error: UIClientFetchError) => ({
    type: ActionTypes.fetchError,
    payload: { error }
  })),
  reset: createAction(() => ({
    type: ActionTypes.reset,
    payload: {}
  }))
};

export type Actions = ActionsUnion<typeof actions>;
